const exploreMoreEls = document.querySelectorAll(".explore-more");

exploreMoreEls?.forEach((el) => {
  if (el.nextElementSibling && el.href) {
    el.nextElementSibling.id = el.href.split("#")[1];
  }
});
